export default {
  "m0": "Charger les détails personnels...",
  "m1": "Veuillez vérifier les champs en surbrillance.",
  "m2": "Votre e-mail d'inscription est lié à votre compte membre sécurisé et ne peut pas être changé ici. S'il vous plaît contacter le club si elle a besoin de corriger.",
  "m3": "Pour une utilisation d'urgence par le personnel autorisé du club seulement.",
  "m4": "Ajouter un membre de famille",
  "m5": "Rechercher un membre actif et envoyer une demande de relation.",
  "m6": "Membre sélectionné",
  "m7": "Famille actuelle",
  "m8": "Aucun membre de la famille n ' est lié",
  "m9": "Ajouter un membre ci-dessus pour lancer une demande de connexion familiale.",
  "m10": "Demandes entrantes",
  "m11": "Demandes en cours",
  "m12": "Gérez les véhicules associés à votre adhésion.",
  "m13": "Cette section vous permettra de:",
  "m14": "Gardez vos niveaux à jour pour de meilleurs jeux, paires et recommandations.",
  "m15": "Entrez le handicap exact",
  "m16": "Nous utiliserons ces niveaux pour améliorer les jeux appropriés, les paires et les recommandations.",
  "m17": "Définir un niveau ci-dessus pour commencer votre profil sportif.",
  "m18": "Modifier la photo",
  "m19": "Portrait en direct",
  "m20": "Membre #",
  "m21": "Votre portrait est en préparation et apparaîtra automatiquement ici.",
  "m22": "Les images sont stockées en toute sécurité et synchronisées avec le profil du portail du club.",
  "m23": "Retour à la salle à manger",
  "m24": "Privana à manger",
  "m25": "Réservations de repas",
  "m26": "L'hospitalité réfléchie, réservée à vous.",
  "m27": "Les heures indiquées dans la fusée temporelle de votre club",
  "m28": "Privana à manger",
  "m29": "Planifiez votre visite",
  "m30": "Trouvez une table",
  "m31": "Modification",
  "m32": "Les aires de repas sont en cours de chargement...",
  "m33": "Les réservations de repas ne sont pas actuellement disponibles.",
  "m34": "Temps privilégié · optionnel",
  "m35": "N'importe quand",
  "m36": "Trouver des tables...",
  "m37": "Votre table vous attend",
  "m38": "Heures disponibles",
  "m39": "Révisez votre réservation",
  "m40": "Notes et demandes spéciales",
  "m41": "Pour les allergies sévères, veuillez également contacter le club directement afin que l'équipe de restauration puisse vous aider en toute sécurité.",
  "m42": "Vos plans",
  "m43": "Votre prochaine table vous attend.",
  "m44": "Choisissez une salle à manger et découvrez un temps disponible.",
  "m45": "Faire une réservation",
  "m46": "Les réservations sont temporairement indisponibles.",
  "m47": "Historique des réservations",
  "m48": "Les réservations de repas passées apparaîtront ici.",
  "m49": "Politique d ' annulation",
  "m50": "Annuler la réservation",
  "m51": "Annuler la réservation ?",
  "m52": "Cela libère votre table et est soumis à la fenêtre d’annulation du club. Cette action ne peut être annulée.",
  "m53": "Réserve de sécurité",
  "m54": "Jouons.",
  "m55": "Qu'est-ce qu'on joue ?",
  "m56": "Nous ne pouvions pas charger Let’s Play en ce moment.",
  "m57": "Aucun sport n’est actuellement disponible pour Let’s Play dans ce club.",
  "m58": "Montrer des sports de club enregistrés.",
  "m59": "Voir l'histoire",
  "m60": "Sport du club",
  "m61": "Aucun parcours de golf actif n'est disponible.",
  "m62": "Golf · Jeu",
  "m63": "Nous ne pouvions pas charger les tees de marque. Vérifiez votre connexion ou connectez-vous à nouveau, puis réessayez.",
  "m64": "Réessayer le chargement des départs",
  "m65": "Tees",
  "m66": "Ce cours n’est pas encore prêt pour Let’s Play.",
  "m67": "Le club a besoin de configurer ses tees de marque avant qu'un round puisse être démarré.",
  "m68": "Choisissez des joueurs",
  "m69": "Golf · Les joueurs",
  "m70": "Les joueurs de Let’s Play Golf rounds finis apparaîtront ici.",
  "m71": "Tour d ' examen",
  "m72": "Continuez.",
  "m73": "Je ne pouvais pas charger vos rounds actifs.",
  "m74": "trous achevés",
  "m75": "Supprimer ce tour ?",
  "m76": "Nous ne pouvions pas supprimer ce tour. Essayez de nouveau.",
  "m77": "Activité non disponible"
}
